export function AttachMoneyIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.325 9.08333C8.4333 8.59167 7.82497 8.08333 7.82497 7.29167C7.82497 6.38333 8.66663 5.75 10.075 5.75C11.5583 5.75 12.1083 6.45833 12.1583 7.5H14C13.9416 6.06667 13.0666 4.75 11.325 4.325V2.5H8.82497V4.3C7.2083 4.65 5.9083 5.7 5.9083 7.30833C5.9083 9.23333 7.49997 10.1917 9.82497 10.75C11.9083 11.25 12.325 11.9833 12.325 12.7583C12.325 13.3333 11.9166 14.25 10.075 14.25C8.3583 14.25 7.6833 13.4833 7.59163 12.5H5.7583C5.8583 14.325 7.22497 15.35 8.82497 15.6917V17.5H11.325V15.7083C12.95 15.4 14.2416 14.4583 14.2416 12.75C14.2416 10.3833 12.2166 9.575 10.325 9.08333Z"
        fill="currentColor"
      />
    </svg>
  )
}
